var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class FsrV1 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'set api_onoff on',
                next: /API\s*Mode:\s*On/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`get scaler_status`, /standby_status\s*(on|off)/i, tags);
                return match[1] === 'off';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`set standby_onoff ${power ? 'off' : 'on'}`, /standby_onoff\s*(on|off)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 6500 : 2000);
                return match[1] === 'off';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`get sw_status`, /Source\s*Select:\s*(.+)/i, tags);
                return match[1].toLowerCase();
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`set sw ${value}`, /Source\s*Select:\s*(.+)|Cannot switch .+ Auto Switch Mode/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 3000);
                if (match[1])
                    return match[1].toLowerCase();
                return this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    regExp: /Source\s*Select:\s*(.+)/i,
                    callback: (match) => {
                        const value = match[1].toLowerCase();
                        this.state.videoMatrixRoutes.update('1', value);
                    },
                },
            ],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`get volgain_data audioout`, /VOLGAIN_DATA audioout (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`set volgain_data audioout ${volume}`, /VOLGAIN_DATA audioout (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 100, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`get audio_mute audioout`, /AUDIOOUT_MUTE audioout (on|off)/i, tags);
                return match[1] === 'on';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`set AUDIO_MUTE audioout ${mute ? 'on' : 'off'}`, /AUDIOOUT_MUTE audioout (on|off)/i, tags);
                return match[1] === 'on';
            }),
        };
        // polling
        this.polls = [{ intervalMs: 4000, controls: ['power'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            // Configure auto switching based on Mal settings.
            yield this.socket.sendAsync(`set autosw_onoff ${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? 'on' : 'off'}`, ['configure']);
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
FsrV1.driverType = 'socketDriver';
FsrV1.key = '-KonV1xSDtrP8VXYosLW';
FsrV1.baseSocketOptions = {};
FsrV1.socketOptions = [
    Object.assign(Object.assign({}, FsrV1.baseSocketOptions), { port: 4999 }),
];
